module.exports = __webpack_public_path__ + "media/country_flags/ml-e57b5d38.png";